import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import salariesService from "./../../api/salariesService";

export const getSalaries = createAsyncThunk(
  "salaries/getSalaries",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const response = await salariesService.getSalaries(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const getHospitalStates = createAsyncThunk(
  "salaries/getHospitalStates",
  async (_, { rejectWithValue }) => {
    try {
      const response = await salariesService.getStates();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const publicGetSalaries = createAsyncThunk(
  "salaries/publicGetSalaries",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const response = await salariesService.publicGetSalaries(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

const initialState = {
  salaries: {},
  salariesInputData: {},
  taxInputData: [],
  isLoading: false,
  isError: false,
  errorMessage: "",
};

const salariesSlice = createSlice({
  name: "salaries",
  initialState,
  reducers: {
    salariesDataAction: (state, action) => {
      state.salariesInputData = action.payload;
    },
    taxInputs: (state, action) => {
      state.taxInputData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSalaries.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(getSalaries.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.salaries = action.payload.salaries || {};
        state.successMessage =
          action.payload.message || "Successfully fetched Salaries Data";
        state.errorMessage = "";
      })
      .addCase(getSalaries.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.errorMessage = action.payload;
        state.successMessage = "";
      })
      .addCase(publicGetSalaries.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(publicGetSalaries.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.salaries = action.payload.salaries || {};
        state.successMessage =
          action.payload.message || "Successfully fetched Salaries Data";
        state.errorMessage = "";
      })
      .addCase(publicGetSalaries.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.errorMessage = action.payload;
        state.successMessage = "";
      });
  },
});

export const { salariesDataAction, taxInputs } = salariesSlice.actions;

export default salariesSlice.reducer;
